import { render, staticRenderFns } from "./TariffCalculatorHeading.vue?vue&type=template&id=3c9bf66e&functional=true&"
import script from "./TariffCalculatorHeading.vue?vue&type=script&lang=js&"
export * from "./TariffCalculatorHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports